module.exports = __webpack_public_path__ + "static/media/plants.ab4d41d0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dashboard/plants.jpeg
// module id = 582
// module chunks = 0